(function(){
  $(function(){
    var swiper = new Swiper('#laptopSwiper', {
      slidesPerView: 3,
      spaceBetween: 32,
	    centeredSlides: true,
	    loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      // autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          
        },
        768: {
          
        },
        540: {
          spaceBetween: 20
        },
        375: {
          centeredSlides: true,
          slidesPerView: 'auto',
          spaceBetween: 20
        }
      }
    });
    var defaultWidth = 100;
    var baseWidth = 375;
    var ratio = window.innerWidth / baseWidth;
    new Swiper('#fingerTopSwiper', {
      spaceBetween: 10,
      loop : true,
      slidesOffsetBefore : defaultWidth*ratio,
      slidesOffsetAfter  : defaultWidth*ratio,
      slidesPerView:2,
      on: {
        resize: function() {
          var ratio = window.innerWidth / baseWidth;
          var _width1 = Math.ceil(defaultWidth * ratio);
          this.params.slidesOffsetBefore = _width1 - 10;
          this.params.slidesOffsetAfter = _width1;
        }
      }
    });
  })

})()